import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { CSSTransitionGroup } from 'react-transition-group';

import Button from 'components/button';

export default class ModalNavigator extends Component {

  /* Lifecycle */

  constructor(props) {
    super(props);
    this.state = {
      activeViewIndex: props.initialStep,
    };

    this.onNextClick = this.onNextClick.bind(this);
    this.onPreviousClick = this.onPreviousClick.bind(this);
  }

  /* Handlers */

  onPreviousClick() {
    this.previous();
  }

  onNextClick() {
    this.next();
  }

  previous() {
    let { activeViewIndex } = this.state;

    if (activeViewIndex > 0) {
      activeViewIndex -= 1;
      this.setState({ activeViewIndex });
    }
  }

  next() {
    let { activeViewIndex } = this.state;
    const { views } = this.props;

    if (activeViewIndex < views.length - 1) {
      activeViewIndex += 1;
      this.setState({ activeViewIndex });
    }
  }

  /* Render */

  render() {
    const { appModalClose, views } = this.props;

    const { title, component } = views[this.state.activeViewIndex];

    return (
      <div className="modal__dialog">
        <div className="modal__header">
          <CSSTransitionGroup
            transitionName="fade"
            transitionEnterTimeout={300}
            transitionLeaveTimeout={300}
          >
            { this.renderPreviousButton() }
          </CSSTransitionGroup>
          <div className="modal__title">{title}</div>
          <Button className="modal__button-close" onClick={appModalClose}>
            <span className="icon-close" />
          </Button>
        </div>
        <div className="modal__content">
          {component}
        </div>
      </div>
    );
  }

  renderPreviousButton() {
    if (this.state.activeViewIndex > 0) {
      return (
        <Button className="modal__button-previous" onClick={this.onPreviousClick}>
          <span className="icon-arrow-left" />
        </Button>
      );
    }

    return null;
  }
}

ModalNavigator.defaultProps = {
  initialStep: 0,
};

ModalNavigator.propTypes = {
  appModalClose: PropTypes.func,
  initialStep: PropTypes.number,
  views: PropTypes.array,
};



// WEBPACK FOOTER //
// ./js/components/modal/navigator/index.jsx